"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M10.9 5.36V4.4a3.4 3.4 0 00-6.8 0v.96a3.4 3.4 0 006.8 0zM7.5 0a4.4 4.4 0 00-4.4 4.4v.96c0 1.08.38 2.07 1.03 2.84a89.9 89.9 0 00-2.25.95c-.37.17-.72.34-.92.46-.44.3-.68.78-.81 1.34a8.85 8.85 0 00-.14 2.1 1 1 0 001 .98h9.5c0-.34.02-.68.08-1H1.01a7.9 7.9 0 01.11-1.86c.1-.43.25-.62.39-.72.12-.08.4-.22.78-.39a44.38 44.38 0 012.66-1.11 4.38 4.38 0 005.06.02 98.33 98.33 0 012.41 1c.32-.24.66-.45 1.03-.62l-.43-.2a45.42 45.42 0 00-2.18-.93 4.38 4.38 0 001.06-2.86V4.4A4.4 4.4 0 007.5 0zm10.36 12.38a.5.5 0 10-.72-.7l-2.96 3.09-.96-1.05a.5.5 0 00-.74.68l1.32 1.44a.5.5 0 00.73 0l3.33-3.46z"
}));

exports["default"] = _default;